module.exports = __webpack_public_path__ + "media/images/official/award_1-259718726d7f01b9f00b5767c5a682d6.png";